import featureFlagSwitcher from './featureFlagSwitcher';

export default function createFeatureDecisions() {
  return {
    isCustomVideoPlayerEnabled() {
      return false;
    },
    isPhoneScreenEnabled() {
      return true;
    },
    isNewCoursesScreenEnabled() {
      return featureFlagSwitcher('newCourseDashboard');
    },
    isTalentSyllabusEnabled() {
      return true;
    },
    isTrainingPlansEnabled() {
      return featureFlagSwitcher('trainingPlans');
    },
    isProfileCompletionEnabled() {
      return featureFlagSwitcher('profileCompletion');
    },
  };
}
